// @ts-strict-ignore
export const PadWithDecimals = (count, value) => {
  // eslint-disable-next-line security/detect-non-literal-regexp
  const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${count}})?`)
  const withDecimals = value.toString().match(regex)[0]
  const [before = '', after = ''] = withDecimals.split('.')
  const val = `${before}.${after.padEnd(count, '0')}`

  return val
}

const FormatStringToLocale = (str) => {
  const removeCommas = str.replace(/,/g, '') || '0'
  return parseInt(removeCommas, 10).toLocaleString('en-GB')
}

export default FormatStringToLocale
